import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { formatDistance, parseJSON } from 'date-fns';
import { jobIconStatusMap, formatTime } from './utils';
import { JobStatus, FlowRun } from '../../types/flow.types';

interface FlowRunDisplayProps {
  flowRun: FlowRun | null;
  nextOrLastRun: 'next' | 'last';
  timezone: string;
  sx?: {
    id?: Record<string, unknown>;
    metadata?: Record<string, unknown>;
  };
}

const FlowRunDisplay = ({
  flowRun,
  nextOrLastRun,
  timezone,
  sx,
}: FlowRunDisplayProps) => {
  const formatTimeTZ = formatTime(timezone);
  return (
    <Tooltip
      title={
        <div>
          <Typography variant="caption" sx={{ fontSize: 10 }}>
            <strong>Id:</strong> {flowRun?.id}
          </Typography>
          <br />
          <Typography variant="caption" sx={{ fontSize: 10 }}>
            <strong>Status:</strong> {flowRun?.status}
          </Typography>
          <br />
          {nextOrLastRun === 'last' && (
            <>
              <Typography variant="caption" sx={{ fontSize: 10 }}>
                <strong>Started at:</strong>{' '}
                {flowRun?.started_at &&
                  formatTimeTZ(parseJSON(flowRun?.started_at))}
              </Typography>
              <br />
              <Typography variant="caption" sx={{ fontSize: 10 }}>
                <strong>Ended at:</strong>{' '}
                {flowRun?.ended_at &&
                  formatTimeTZ(parseJSON(flowRun?.ended_at))}
              </Typography>
            </>
          )}

          {nextOrLastRun === 'next' && (
            <Typography variant="caption" sx={{ fontSize: 10 }}>
              <strong>Queued Time:</strong>{' '}
              {flowRun?.run_at && formatTimeTZ(parseJSON(flowRun.run_at))}
            </Typography>
          )}
        </div>
      }
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'flex-start',
        }}
      >
        <span style={{ marginRight: '4px' }}>
          {flowRun?.status && jobIconStatusMap[flowRun.status as JobStatus]}
        </span>
        <div>
          {flowRun && (
            <Typography
              variant="body2"
              color="inherit"
              sx={{ ...(sx?.id || {}) }}
            >
              {flowRun?.id.split('-')[flowRun?.id.split('-').length - 1]}
            </Typography>
          )}

          {flowRun?.status === 'running' && (
            <Typography
              fontSize={12}
              variant="body2"
              color="text.secondary"
              sx={{ ...(sx?.metadata || {}) }}
            >
              running
            </Typography>
          )}

          {nextOrLastRun === 'next' && flowRun?.run_at && (
            <Typography
              fontSize={10}
              variant="body2"
              color="text.secondary"
              sx={{ ...(sx?.metadata || {}) }}
              data-cy="queued-time"
            >
              <strong>Queued Time:</strong>
              <br />
              {formatTimeTZ(parseJSON(flowRun.run_at))}
            </Typography>
          )}

          {flowRun && flowRun.ended_at && nextOrLastRun === 'last' && (
            <>
              <Typography
                fontSize={10}
                variant="body2"
                color="text.secondary"
                sx={{ ...(sx?.metadata || {}) }}
                data-cy="ended-at-time"
              >
                {formatTimeTZ(parseJSON(flowRun.ended_at))}
              </Typography>
              <Typography
                fontSize={10}
                variant="body2"
                color="text.secondary"
                sx={{ ...(sx?.metadata || {}) }}
                data-cy="run-time"
              >
                <strong> Run Time: </strong>
                {formatDistance(
                  parseJSON(flowRun.ended_at),
                  parseJSON(flowRun.started_at || ''),
                )}
              </Typography>
            </>
          )}
        </div>
      </div>
    </Tooltip>
  );
};

export default FlowRunDisplay;
